import React from "react";
import "./Settings.css";
function Settings() {
  return (
    <div className="settings">
      <h1>I am at Settings page.</h1>
    </div>
  );
}

export default Settings;
